<ng-template
  let-extraClass="extraClass"
  #topNav>
  <tidy-top-nav
    [class]="extraClass"
    [title]="text?.title"
    [canGoBack]="true" />
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>


    <tidy-row [align]="'center'">
       <tidy-text
         [body]="'What would you like to do?'" />
     </tidy-row>

    <tidy-button
     [text]="text?.buttonOne"
     [action]="boundReschedule"
     class="primary" />

    <tidy-button
     [text]="text?.buttonTwo"
     [action]="boundCancel"
     class="secondary" />

  </tidy-wrapper>
</ng-template>

<app-scroll-wrapper [templateContent]="content" />
